import { jsx as o } from "react/jsx-runtime";
import { getIconStyles as l } from "../styles.js";
const t = (e) => /* @__PURE__ */ o(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: l(e),
    children: /* @__PURE__ */ o(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9997 15.7523L22.2088 5.54313C22.5993 5.1526 23.2325 5.1526 23.623 5.54313C24.0135 5.93365 24.0135 6.56682 23.623 6.95734L13.2375 17.3429C13.0752 17.5053 12.8819 17.6347 12.6698 17.7226C12.4574 17.8107 12.2298 17.856 11.9999 17.856C11.77 17.856 11.5424 17.8107 11.33 17.7226C11.118 17.6347 10.9253 17.5059 10.763 17.3436L10.7623 17.3429L0.353762 6.95815C-0.0372094 6.56807 -0.0379341 5.93491 0.352143 5.54394C0.74222 5.15297 1.37538 5.15224 1.76636 5.54232L11.9997 15.7523Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  t as ChevronDownIcon
};
//# sourceMappingURL=ChevronDownIcon.js.map
